<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/19eK7wF/media/FC-9781645755449.jpg?1685790544041" alt="This image is the cover for the book The Memphite Equation"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Memphite Equation
      </h1>
      <p class="bookDescription body article font2">
        <p style='margin-right:0cm;margin-left:0cm;font-size:16px;font-family:"Times New Roman",serif;margin:0cm;margin-bottom:.0001pt;text-align:justify;background:white;'><span style='font-family:"Arial",sans-serif;color:black;'>The locations and physical descriptions are factual – the prophetic embellished future is yet to be foretold.</span></p><p style='margin-right:0cm;margin-left:0cm;font-size:16px;font-family:"Times New Roman",serif;margin:0cm;margin-bottom:.0001pt;text-align:justify;background:white;'><br/></p><p style='margin-right:0cm;margin-left:0cm;font-size:16px;font-family:"Times New Roman",serif;margin:0cm;margin-bottom:.0001pt;text-align:justify;background:white;'><span style='font-family:"Arial",sans-serif;color:black;'>During July 15–17, 2007, an epochal event occurred in Manchester, England – the first international biblical conference on the 3000-year-old copper scroll, which later brewed a dangerous controversy. The copper scroll is among a group of scrolls found in 1947 and 1952, but this is the only one carved in metal and is not strictly a religious scroll.</span></p><p style='margin-right:0cm;margin-left:0cm;font-size:16px;font-family:"Times New Roman",serif;margin:0cm;margin-bottom:.0001pt;text-align:justify;background:white;'><br/></p><p style='margin-right:0cm;margin-left:0cm;font-size:16px;font-family:"Times New Roman",serif;margin:0cm;margin-bottom:.0001pt;text-align:justify;background:white;'><span style='font-family:"Arial",sans-serif;color:black;'>Dr. David E. Burton, a recent Harvard graduate, attended the conference. After Q&amp;A, when what he saw didn’t come up, feeling baffled, he shared his idea that there was an equation on the scroll. From that moment, his life, family, an old and enigmatic organization (existing since 1863) he later joins, and the world change forever.</span></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Nathaniel Cameron
      </h2>
      
      <p class="authorDescription body article"><p style='margin:0cm;font-size:13px;font-family:"Times New Roman",serif;margin-right:17.85pt;text-align:justify;'><span style="font-size:15px;">Nathaniel Cameron is a former paratrooper, boxer, inventor, entrepreneur, chemist, and practiced medicine for over 30 years. This is his first novel, it&rsquo;s an international political thriller that begins with pursuit of a 3000-year-old treasure, and ends in transfiguration.</span></p></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?018ca0ca